export enum SystemPageKey {
    CompareMachines = 'CompareMachines',
    Dashboard = 'Dashboard',
    InternalServerError = 'InternalServerError',
    NotFound = 'NotFound',
    PDP = 'MachineDetails',
    SearchResults = 'SearchResults',
    StartPage = 'StartPage',
}
